/* global axios */
import ApiClient from './ApiClient';

class InternalCommunicationAPI extends ApiClient {
  constructor() {
    super('internal_communication', { accountScoped: true });
  }

  get roomsUrl() {
    return `${this.url}/rooms`;
  }

  getRooms() {
    return axios.get(this.roomsUrl);
  }

  getRoom(roomId) {
    return axios.get(`${this.roomsUrl}/${roomId}`);
  }

  createRoom(room) {
    return axios.post(this.roomsUrl, { room });
  }

  updateRoom(roomId, room) {
    return axios.patch(`${this.roomsUrl}/${roomId}`, { room });
  }

  archiveRoom(roomId) {
    return axios.delete(`${this.roomsUrl}/${roomId}`);
  }

  leaveRoom(roomId) {
    return axios.post(`${this.roomsUrl}/${roomId}/leave`);
  }

  getMessages(roomId, beforeSequence) {
    return axios.get(`${this.roomsUrl}/${roomId}/messages`, {
      params: { before_sequence: beforeSequence },
    });
  }

  createMessage(roomId, message) {
    return axios.post(`${this.roomsUrl}/${roomId}/messages`, { message });
  }

  updateMessage(roomId, messageId, message) {
    return axios.patch(`${this.roomsUrl}/${roomId}/messages/${messageId}`, {
      message,
    });
  }

  deleteMessage(roomId, messageId, reason) {
    return axios.delete(`${this.roomsUrl}/${roomId}/messages/${messageId}`, {
      data: { reason },
    });
  }

  markRead(roomId) {
    return axios.post(`${this.roomsUrl}/${roomId}/read`);
  }

  getMentionableUsers(roomId) {
    return axios.get(`${this.roomsUrl}/${roomId}/mentionable_users`);
  }

  addMembers(roomId, userIds) {
    return axios.post(`${this.roomsUrl}/${roomId}/memberships`, {
      membership: { user_ids: userIds },
    });
  }

  removeMember(roomId, userId) {
    return axios.delete(`${this.roomsUrl}/${roomId}/memberships/${userId}`);
  }

  searchConversations(query) {
    return axios.get(`${this.url}/conversation_references/search`, {
      params: { q: query },
    });
  }

  resolveConversationReference(referenceId) {
    return axios.get(`${this.url}/conversation_references/${referenceId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  downloadAttachment(url) {
    return axios.get(url, { responseType: 'blob' });
  }
}

export default new InternalCommunicationAPI();
